'use strict';

bbw.model.Post = ngtk.model.Item.extend({

    $q: undefined,

    /**
     * @type {bbw.model.PhotoCollection}
     */
    photos: undefined,

    $inject: ['modelFactory', 'rpcClient', '$q', 'bbw.ServerTimeSvc', '$rootScope'],

    construct: function(modelFactory, rpcClient, $q, serverTime, $rootScope) {
        this._api = rpcClient;
        this._modelFactory = modelFactory;
        this.$q = $q;
        this.$rootScope = $rootScope;
        this._bbwServerTimeSvc = serverTime;
        this._initialize();
    },

    _initialize: function() {
        this.photos = this._modelFactory.create(bbw.model.PhotoCollection).setPhotosLimit(bbw.configuration.post.attached_photos_limit);
        this._data = {
            contents: ''
        };
    },

    setContents: function(contents, photos) {
        this._data.contents = '' + contents;
        this.photos.replace(photos._items);
        return this;
    },

    setTitle: function(title) {
        this._data.title = '' + title;
        return this;
    },

    setCollectionIdentifier: function(collectionIdentifier) {
        this._data.collection_identifier = collectionIdentifier;
        return this;
    },

    isEditable: function() {
        if (!this._data.id) {
            return true;
        }
        if (!this._data.is_editable) {
            return false;
        }
        if (this._data.editable_before_ts) {
            return this.getEditTimeRemaining() > 0;
        }
        return true;
    },

    getEditTimeRemaining: function() {
        if (!this._data.is_editable) {
            return null;
        }
        if (this._data.editable_before_ts) {
            var editableBefore = this._bbwServerTimeSvc.toClientTimestamp(this._data.editable_before_ts);
            var now = (+new Date()) / 1000;
            return Math.max(0, editableBefore - now);
        }
        return null;
    },

    toggleLike: function() {
        var isLike = !this.get('i_like');
        return this.like(isLike);
    },

    like: function(isLike) {
        return this._api.post('like', {
            entity_type: "post",
            id: this.get('id'),
            like: !!isLike
        }).execute().then(function(response) {
            this.merge({likes_count: response.likes_count, i_like: !!response.i_like, likes: response.likes});
        }.bind(this));
    },

    close: function(isClosed) {
        if (angular.isUndefined(isClosed)) {
            isClosed = true;
        }
        return this._api.post('posts/close', {
            id: this.get('id'),
            close: !!isClosed
        }).execute().then(function(response) {
            this.merge({is_closed: !!response.is_closed});
            return !!response.is_closed;
        }.bind(this));
    },

    empty: function() {
        angular.forEach(this._data, function(value, key) {
            if (key.charAt(0) != '$' && key !== 'type_name') {
                delete this._data[key];
            }
        }.bind(this));
        this._data.contents = '';
        return this;
    },

    load: function(typeName, id) {
        return this._loadFromApi('get', 'posts/{type_name}/{id}', {
            type_name: typeName,
            id: id
        }).then(function(response) {
            this._setFromApiResult(response.post);
        }.bind(this));
    },

    loadAllLikes: function() {
        return this._api.get('likes/post/' + this.get('id')).execute().then(function(response) {
            this.merge({likes_all: response.likes});
        }.bind(this));
    },

    reload: function() {
        return this.load(this.get('type_name'), this.get('id'));
    },

    sendAbuse: function(abuse, isHide) {
        return this._api.post('abuse/submit', {
            entity_type: 'post',
            id: this.get('id'),
            reason: abuse.reason,
            desc: abuse.desc || undefined,
            hide: !!isHide
        }).execute().then(function(response) {
            isHide && angular.isObject(response.entity) && this.merge(response.entity);
        }.bind(this));
    },

    approve: function() {
        return this._api.post('posts/edit', {
            id: this.get('id'),
            is_visible: true
        }).execute().then(function(response) {
            var data = response.post;
            this.merge({
                is_visible: data.is_visible,
                moderated_at: data.moderated_at
            });
        }.bind(this));
    },

    save: function(updateFromApi) {
        if (!this.isValid()) {
            return this.$q.reject('post_is_empty');
        }
        var action = this._data.id ? 'posts/edit' : 'posts/add';
        var signal = !this._data.id;
        return this._api.post(action, this._exportForApiWrite()).execute().then(function(response) {
            if (updateFromApi !== false) {
                this._setFromApiResult(response.post);
            }
            if (signal) {
                this.$rootScope.$broadcast(bbw.event.USER_POST_ADDED);
            }
        }.bind(this));
    },

    delete: function() {
        if (!this._data.id) {
            throw new Error("ID is not allocated, cannot delete post");
        }
        return this._api.post('posts/delete', {id: this._data.id}).execute();
    },

    toggleSubscribe: function() {
        return this.subscribe(!this.get('is_subscribed'));
    },

    subscribe: function(isSubscribed) {
        if (!this._data.id) {
            throw new Error("ID is not allocated, cannot (un)subscribe");
        }
        if (angular.isUndefined(isSubscribed)) {
            isSubscribed = true;
        }
        var action = 'subscription/' + (!isSubscribed ? 'unsubscribe' : 'subscribe');
        return this._api.post(action, {type: "post", entity_id: this.get('id')}).execute().then(function(response) {
            this.merge({is_subscribed: !!response.is_subscribed});
        }.bind(this));
    },

    unsubscribe: function() {
        return this.subscribe(false);
    },

    hasPhotos: function() {
        return this.photos.getLength() > 0;
    },

    hasContents: function() {
        return angular.isString(this._data.contents) && this._data.contents.trim().length > 0;
    },

    getContents: function() {
        return this.hasContents() ? this._data.contents : '';
    },

    getTitle: function() {
        return this._data.title || '';
    },

    getCollectionIdentifier: function() {
        return this._data.collection_identifier;
    },

    isValid: function() {
        return this._data.type_name && (this.hasContents() || this.hasPhotos());
    },

    wireCommentsScope: function(commentsCollection) {
        if (commentsCollection) {
            commentsCollection.wireScope(this._data, 'comments');
        } else {
            delete this._data.comments;
        }
    },

    _wireScope: function(scope, scopeInnerPtr, scopeInnerElement) {
        scopeInnerPtr[scopeInnerElement] = this._data;
        scopeInnerPtr[scopeInnerElement].$model = this;
        this.photos.wireScope(scopeInnerPtr[scopeInnerElement], 'photos');
    },

    _extractIdFromItemData: function(itemData) {
        return itemData.id;
    },

    _setFromApiResult: function(itemData, updatePhotos) {
        var photos = itemData.photos;
        delete itemData.photos;
        this.replace(this._parseItemData(itemData));
        delete this._data.comments;
        angular.isObject(photos) && this.photos.replace(photos.items || []);
    },

    _exportForApiWrite: function() {
        return {
            'id': this._data.id || undefined,
            'type_name': this._data.type_name,
            'collection_identifier': this._data.collection_identifier || undefined,
            'title': this._data.title || undefined,
            'contents': this._data.contents,
            'as_admin': this._data.as_admin,
            'photo_ids': this.photos.exportPhotoIds()
        };
    }

});
